<div id="overlay" class="show theModal">
    <div id="modal-container">
        <ng-content></ng-content>
    </div>
</div>